import apolloClient from '@/libs/apollo'
import minhasEmpresas from '@/libs/apollo/queries/conta'
import createDownload from '@/libs/apollo/queries/download'

export default {
  async clearMinhasEmpresas({ commit }) {
    commit('SET_MINHAS_EMPRESAS', [])
  },

  async fetchMinhasEmpresas({ commit }) {
    const response = await apolloClient.query({
      query: minhasEmpresas,
      fetchPolicy: 'network-only',
    })

    commit('SET_MINHAS_EMPRESAS', response.data.minhasEmpresas)
  },
  /* eslint-disable-next-line */
  async fetchDownloadURL({ commit }, { tempo, key }) {
    return apolloClient.mutate({
      mutation: createDownload,
      variables: { tempo, key },
      fetchPolicy: 'no-cache',
    })
  },
}
